// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper___i3hj","title":"ClientReferral_title__2IiZz","itemText":"ClientReferral_itemText__mgTTI"};